import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import MainView from '../components/MainView/MainView'
import { setAccessToken } from '../../../modules/auth/actions/creators'
import {
  setDeleteRequestId,
  setDeleteMaskedData,
  setDeleteOtpToMobile,
} from '../../../modules/delete-account/actions/creators'

const mapStateToProps = reduxState => {
  const {
    //  deleteAccount,
    auth,
  } = reduxState
  const { accessToken } = auth
  return {
    // to add redux state here
    accessToken,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccessToken,
      setDeleteRequestId,
      setDeleteMaskedData,
      setDeleteOtpToMobile,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
